// import { Redirect } from "react-router-dom"
import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getMostSpentCustomersApi} from "../../Service/Api/MostSpentCustomersApi"
import {getMostSpentList,getErrors} from "../Reducer/MostSpentCustomersReducer"
 

// Watchers
function* mostSpentCustomersSaga() {
	yield takeEvery("most_spent/getMostSpent", getAllMostSpentCustomers)
}

// Sagas
function* getAllMostSpentCustomers(action) {
 
	try {
		const getTopSpentData = yield call(getMostSpentCustomersApi, action.payload)
	 

		if (getTopSpentData.request.status === 200) {
			 
			yield put(getMostSpentList(getTopSpentData))
		} else {
		 
			yield put(getErrors(true))
		}
	} catch (error) {
		 
		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(mostSpentCustomersSaga)])
}
